import React from "react";
import { useLocation } from "react-router-dom";
import { useEffect, useState, useMemo } from "react";
import GetApiService from "Components/Api/getapiService.jsx";
import { useAdminData } from "../AdminPanel/AdminSettings/useAdminData";
import { ClipLoader } from "react-spinners";
import ErrorModal from "Components/Other Functions/popup";
import { AddStockFields } from "Components/support/Allfields/addstock";
import { toPlainFields } from "Components/support/Allfields/fieldconverter";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
import { useSelector } from "react-redux";


export default function BulkProductEdit() {

    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState(null);
    const [showModal, setShowModal] = useState(false); // Modal visibility state
    const allStates = useSelector((state) => state);
    const adminLoggedIn = allStates.reducer1;

    //main data array
    const [productTypeData, setProductTypeData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [purityData, setPurityData] = useState([]);
  const [partyData, setPartyData] = useState([]);
  const [boxData, setBoxData] = useState([]);
  const [collectionTypeData, setCollectionTypeData] = useState([]);
  const [collectionmainlist, setCollectionmainlist] = useState([]);
  const [branchOption, setBranchOption] = useState([]);
  const [stonemaster, setStonemaster] = useState([]);
  const [rifdData, setRifdData] = useState([]);
  const [allDiamondSizeWeightRate, setAllDiamondSizeWeightRate] = useState([]);
  const [allDiamondAttributes, setAllDiamondAttributes] = useState([]);
  const [allLabelledStockData, setAllLabelledStockData] = useState([]);

    const location = useLocation();
    const selectedProducts = location.state?.selectedProducts || [];

    useEffect(() => {
        console.log("Selected Products:", selectedProducts);
    }, [selectedProducts]);

    const {
        clientCode,
        CompanyId,
        CounterId,
        BranchId,
        EmployeId,
        employeeCode,
        rdPurchaseFormat,
    } = useAdminData();

    const apiService = new GetApiService(clientCode);

    const loadData = async () => {
        setLoading(true);
        try {
            const apiCalls = [

                apiService.fetchAllCategories(),
                apiService.fetchAllProductType(),
                apiService.fetchAllDesigns(),
                apiService.fetchPaginatedData({
                    ClientCode: clientCode,
                    CategoryId: 0,
                    DesignId: 0,
                    ProductId: 0,
                    PurityId: 0,
                    Status: "all",
                    Id: 0, // Initial ID (will be overwritten in the method)
                    Size: "500", // Number of items per page
                    UpdatedFrom: "Web",
                }),

            ];

            const results = await Promise.allSettled(apiCalls);

            results.forEach((result, index) => {
                if (result.status === "fulfilled") {
                    // Handle successful response
                    switch (index) {
                        case 0:

                        if (Array.isArray(result.value)) {
                            // Check if the first item's CategoryName is 'Gold'
                            if (
                              result.value.length > 0 &&
                              result.value[0].CategoryName !== "GOLD"
                            ) {
                              setCategoriesData(result.value.reverse());
                            } else {
                              // Set data as-is (without reversing) if the first item is 'Gold'
                              setCategoriesData(result.value);
                            }
                          } else {
                            setErrorMessage(
                              "Error: Unexpected response format for Categories."
                            );
                          }
                            break;
                        case 1:
                            
                            setProductTypeData(result.value);
                            break;
                        case 2:
                            setCollectionTypeData(result.value);
                            break;
                        case 3:
                            console.log('check all data', result.value)
                            setAllLabelledStockData(result.value);

                            // let data = result.value;
                            
                            // let branchProducts = data;
                            // console.log(branchProducts, "branchProducts");
                            // // Add a serial number property to each product
                            // if (selectBranch === "Home" || selectBranch === "Branch 2") {
                            //     branchProducts = data.filter((x) => x.BranchName === selectBranch);
                            // } else {
                            //     branchProducts = data;
                            // }

                            // const activeProducts = branchProducts.filter((product) => product.Status === "Active");

                            // console.log('check all active', activeProducts)

                            // // Add a serial number property to each product
                            // const productsWithSerial = activeProducts.map((product, index) => ({
                            //     ...product,
                            //     serialNumber: index + 1,
                            // }));
                            // setAllProducts(productsWithSerial.reverse());
                            // //   setAllProducts(data.data);
                            // setDeleteSelected(false);
                            // console.log(productsWithSerial, "productsWithSerial");
                            break;

                        default:
                            break;
                    }
                } else {
                    if (index + 1 > 1) {
                        console.error(
                            `Error loading data for API ${index + 1}:`,
                            result.reason
                        );
                        handleError(
                            `Failed to load data for API ${index + 1}: ${result.reason}`
                        );
                    }
                }
            });
        } catch (error) {
            console.error("Error loading data:", error);
            handleError("Error loading data. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, [clientCode]);

    const apifields = useMemo(
        () => adminLoggedIn.Modules.filter((module) => module.PageName === "add_bulk_stock_new"),
        [adminLoggedIn]
    );

    const localfields = useMemo(() => toPlainFields(AddStockFields), []);
    const apifieldsControls = useMemo(() => apifields[0]?.PageControls || [], [apifields]);

    console.log('check localfields  ', localfields);


    const [itemfields, setItemfields] = useState(() => {
        const updatedFields = localfields.map((localField) => {
            const matchingApiField = apifieldsControls.find(
                (apiField) => apiField.key === localField.key && apiField.place === localField.place
            );
            if (matchingApiField) {
                return {
                    ...localField,
                    label: matchingApiField.label,
                    placeholder: matchingApiField.placeholder,
                    priority: matchingApiField.priority,
                    type: localField.type,
                    visibility: matchingApiField.visibility,
                    place: matchingApiField.place,
                    value: ''
                };
            }
            return localField;
        });

        console.log('check update fields ', updatedFields);

        return updatedFields;
    });


    const handleError = (message) => {
        setErrorMessage(message);
        setShowModal(true); // Open the modal
    };
    const reloadData = () => {
        setShowModal(false); // Close the modal
        loadData(); // Reload data
    };





    return (
        <div>
            <div>
                <AdminHeading />

                {loading ? (
                    // Show spinner while loading
                    <div className="spinner-container">
                        <ClipLoader size={50} color={"#123abc"} loading={loading} />
                        <p>Loading data...</p>
                    </div>
                ) : (
                    <div>
                        <ErrorModal
                            isOpen={showModal}
                            onRequestClose={() => {
                                setShowModal(false); // Close the modal
                                navigate("/adminhome"); // Redirect to /adminhome
                            }}
                            onReload={reloadData} // Pass reload function
                            message={errorMessage}
                        />

                        <div className="adminMainBodyBox" id="addBulkProductsBoxTop">
                            <AdminBreadCrump
                                title={"Add Bulk Stock"}
                                companyName={"Loyalstring"}
                                module={"E-commerce"}
                                page={"Add Bulk Stock"}
                            />
                            <div className="adminAddCategoryMainBox2-stock">

                            </div>
                        </div>



                    </div>
                )
                }
            </div>


        </div>

    )
}